var React = require('react');

function IconChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 16.5L4.5 9l1.05-1.05L12 14.4l6.45-6.45L19.5 9 12 16.5z"}));
}

IconChevronDown.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconChevronDown;

IconChevronDown.default = IconChevronDown;
